import { render, staticRenderFns } from "./PopUpCancelFile.vue?vue&type=template&id=11438080&scoped=true&"
import script from "./PopUpCancelFile.vue?vue&type=script&lang=js&"
export * from "./PopUpCancelFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpCancelFile.vue?vue&type=style&index=0&id=11438080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11438080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11438080')) {
      api.createRecord('11438080', component.options)
    } else {
      api.reload('11438080', component.options)
    }
    module.hot.accept("./PopUpCancelFile.vue?vue&type=template&id=11438080&scoped=true&", function () {
      api.rerender('11438080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/modals/PopUpCancelFile.vue"
export default component.exports